<template>
  <BasicModal
    :title="'メディア作成'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container">
      <div class="input-field">
        <p>{{type === 'image' ? '画像' : '動画'}}ファイル</p>
        <b-upload :accept="getAccept" v-model="createMedia.file" drag-drop :disabled="isSaving">
          <section class="upload-section disp-scroll">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-large"></b-icon>
              </p>
              <p>ファイルをアップロードしてください</p>
            </div>
          </section>
        </b-upload>
        <div class="file-name-container">
          ファイル名：
          <template v-if="createMedia.file">
            <p>
              {{createMedia.file.name}}
              <span @click="deleteFile()" style="cursor: pointer;" class="mdi mdi-close -left-8px"></span>
            </p>
          </template>
          <p v-else>
            未アップロードです。
          </p>
        </div>
      </div>
      <div class="input-field">
        <p>タグ</p>
        <template v-if="createMedia.tag">
          <div class="tag is-primary" style="margin-right: 5px; margin-bottom: 5px;" v-for="(t, i) in createMedia.tag" :key="i" v-show="t != ''">
            {{t}}
            <span class="mdi mdi-close" style="margin-left: 8px; cursor: pointer;" @click="deleteTags(i)"></span>
          </div>
        </template>
        <input class="input is-primary" placeholder="タグを設定" v-model="tag" ref="tag" @focus="isClickTag = true" @keypress.enter="addTags(tag)" :disabled="isSaving"/>
        <div v-if="isClickTag">
          <button class="tag is-primary" style="margin: 4px;"  v-for="(t, i) in filteredTagsList" :key="i"  @click="addTags(t)" :disabled="isSaving">
            {{t}}
          </button>
        </div>
      </div>
      <div style="text-align: center; margin: 8px 0px;" v-if="isSaving">
        <div>
          <span class="mdi mdi-spin mdi-loading"></span>
          アップロード中です。
          通信状況により時間がかかる場合があります。
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel" :disabled="isSaving">キャンセル</button>
      <button class="button is-primary" @click="createMediaPool(createMedia)" :disabled="isSaving">作成する</button>
    </div>
  </BasicModal>
</template>

<script>
import { mapState } from 'vuex'
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  components: {
    BasicModal
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    images: {
      type: Array,
      required: false
    },
    videos: {
      type: Array,
      required: false
    },
  },
  computed: {
    ...mapState('mediapool', ['isImageSaving', 'isVideoSaving']),
    getAccept () {
      if (this.type === 'image') {
        return 'image/*'
      } else {
        return 'video/*'
      }
    },
    filteredTagsList() {
      // 入力された文字に一致するタグだけフィルタリング
      if (this.searchTags.length === 0) return
      return this.searchTags.filter((option) => {
        if (!this.tag) return true
        return option
          .toString()
          .toLowerCase()
          .indexOf(this.tag.toLowerCase()) >= 0
      })
    },
    searchTags () {
      let allTags = this.tagList
      let tagsMedia = this.tpe === 'image' ? this.images : this.videos
      for (let image of tagsMedia) {
        // 各メディアのタグを収集
        if (image.tags) {
          // 空を除いて全て配列化
          var tagInfo = []
          var tags = image.tags.split(',').filter(Boolean)
          for (let tag of tags) {
            tagInfo.push(tag)
          }
          allTags = allTags.concat(tagInfo)
        }
      }
      // 重複を削除してソート
      let tagsListTemp = this.$_.union(allTags)
      return tagsListTemp.sort(function(tag1, tag2){
        if (tag1.tag > tag2.tag) return 1
        return -1
      })
    },
    isSaving () {
      return this.isImageSaving || this.isVideoSaving
    }
  },
  created () {
    // 初期化
    this.createMedia = {
      file: null,
      tag: []
    }
  },
  data () {
    return {
      createMedia: {
        file: null,
        tag: []
      },
      tag: null,
      isClickTag: false,
      tagList:[
        "採用",
        "求人",
        "求人ノベル",
        "求人ページ",
        "人物",
        "背景",
        "ロボ",
      ],
    }
  },
  watch: {
    isSaving () {
      if (!this.isSaving) this.cancel()
    },
  },
  methods: {
    cancel () {
      this.$emit('cancel', {
        flg: false,
        type: null
      })
      this.createMedia = {
        file: null,
        tag: []
      }
    },
    addTags (tag) {
      if (!tag) {
        alert('一文字以上入力してください。')
        return
      }
      this.createMedia.tag.push(tag)
      this.tag = null
    },
    deleteTags (i) {
      this.createMedia.tag.splice(i, 1)
    },
    createMediaPool (data) {
      if (!data.file) {
        alert('ファイルをアップロードしてください')
        return
      }
      this.sendControlLog('メディア倉庫　作成', '')
      if (this.createMedia.tag.length === 1) {
        data.tags = this.createMedia.tag[0]
      } else if (this.createMedia.tag.length > 1) {
        data.tags = this.$_.union(this.createMedia.tag).join(',')
      } else {
        data.tags = ''
      }
      this.$emit('createMediaPool', {
        data: data,
        type: this.type
      })
    },
    deleteFile () {
      this.createMedia.file = null
    }
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 8px;
  height: auto;
  overflow: auto;
}
.input-field {
  padding: 8px;
  text-align: left;
  p {
    font-weight: 600;
    margin-bottom: 2px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.file-name-container {
  display: flex;
  margin-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/ui/ModalCreateMedia.vue